var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoToTrainingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5307 21.3333H17.4693L19.3153 29.3333H20.684L18.838 21.3333H29.3333C30.0687 21.3333 30.6667 20.7353 30.6667 20V5.33333H31.3333C31.7013 5.33333 32 5.03467 32 4.66667C32 4.29867 31.7013 4 31.3333 4H16.6667V2H15.3333V4H0.666667C0.298667 4 0 4.29867 0 4.66667C0 5.03467 0.298667 5.33333 0.666667 5.33333H1.33333V20C1.33333 20.7353 1.93133 21.3333 2.66667 21.3333H13.162L11.316 29.3333H12.6847L14.5307 21.3333ZM2.66667 5.33333H29.3333L29.334 20H2.66667V5.33333Z",
    fill: "#031434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 10H13.3333C13.7013 10 14 9.70133 14 9.33333C14 8.96533 13.7013 8.66667 13.3333 8.66667H5.33333C4.96533 8.66667 4.66667 8.96533 4.66667 9.33333C4.66667 9.70133 4.96533 10 5.33333 10Z",
    fill: "#031434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16C14 15.632 13.7013 15.3333 13.3333 15.3333H5.33333C4.96533 15.3333 4.66667 15.632 4.66667 16C4.66667 16.368 4.96533 16.6667 5.33333 16.6667H13.3333C13.7013 16.6667 14 16.368 14 16Z",
    fill: "#031434"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3687 16.5967C18.464 16.644 18.566 16.6667 18.666 16.6667C18.9107 16.6667 19.146 16.532 19.2633 16.298L21.0047 12.8153L24.456 13.966C24.77 14.0707 25.1147 13.928 25.2633 13.632L27.2633 9.632C27.428 9.30267 27.2947 8.902 26.9653 8.73733C26.6353 8.572 26.2353 8.706 26.0707 9.03533L24.3293 12.518L20.878 11.3673C20.5627 11.2627 20.2193 11.4053 20.0707 11.7013L18.0707 15.7013C17.9053 16.0313 18.0393 16.4313 18.3687 16.5967Z",
    fill: "#031434"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 13.3333H13.3333C13.7013 13.3333 14 13.0347 14 12.6667C14 12.2987 13.7013 12 13.3333 12H5.33333C4.96533 12 4.66667 12.2987 4.66667 12.6667C4.66667 13.0347 4.96533 13.3333 5.33333 13.3333Z",
    fill: "#031434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToTrainingIcon);
export default __webpack_public_path__ + "static/media/go_to_training_icon.0a3fd411faeef882f62719b97ad7ddd9.svg";
export { ForwardRef as ReactComponent };